module.exports = __webpack_public_path__ + "img/users.893b2e4a.svg";